export enum GameStateType {
  AcceleratingSpinner,
  DwarfInTheAir,
  DwarfLanded
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/GameStateType.ts